import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-icon',
  templateUrl: './booking-icon.component.html',
  styles: []
})
export class BookingIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
